import JsBarcode from "jsbarcode";
import { api } from "./apiClient";

// Standard Avery-like label sizes (millimeters)
export const LABEL_FORMATS = {
  "70x37": { w: 70, h: 37, cols: 3, rows: 8, label: "Avery 3475 — 70×37 mm (24 per foglio)" },
  "63.5x38.1": { w: 63.5, h: 38.1, cols: 3, rows: 7, label: "Avery L7160 — 63.5×38.1 mm (21 per foglio)" },
  "99.1x33.9": { w: 99.1, h: 33.9, cols: 2, rows: 8, label: "Avery L7159 — 99.1×33.9 mm (16 per foglio)" },
  "100x50": { w: 100, h: 50, cols: 2, rows: 5, label: "Etichetta pallet — 100×50 mm (10 per foglio)" },
};

function renderBarcodeSVG(value) {
  if (!value) return "";
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  try {
    JsBarcode(svg, String(value), {
      format: "CODE128",
      displayValue: false,
      margin: 0,
      height: 40,
      width: 1.6,
    });
  } catch {
    return `<div style="font-family:monospace;font-size:9px;color:#dc2626">${value}</div>`;
  }
  return new XMLSerializer().serializeToString(svg);
}

export async function printLabels(items, opts = {}) {
  // items: [{ product, copies }]
  const format = LABEL_FORMATS[opts.format] || LABEL_FORMATS["70x37"];
  const company = await api.get("/settings/company").then(r => r.data).catch(() => ({}));

  const expanded = [];
  for (const { product, copies } of items) {
    const n = Math.max(1, parseInt(copies || 1, 10));
    for (let i = 0; i < n; i++) expanded.push(product);
  }
  if (expanded.length === 0) return;

  const esc = (v) => String(v ?? "").replace(/[&<>]/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[ch]));

  const cellHtml = (p) => {
    const code = p.barcode || p.sku;
    const bc = renderBarcodeSVG(code);
    return `<div class="label">
      ${company.name ? `<div class="brand">${esc(company.name)}</div>` : ""}
      <div class="pname">${esc(p.name)}</div>
      <div class="barcode">${bc}</div>
      <div class="meta">
        <span class="sku">SKU: <b>${esc(p.sku)}</b></span>
        ${p.barcode ? `<span class="ean">EAN: <b>${esc(p.barcode)}</b></span>` : ""}
      </div>
    </div>`;
  };

  const w = window.open("", "_blank", "width=900,height=1100");
  if (!w) return;

  const style = `
    @page { size: A4; margin: 8mm; }
    * { box-sizing: border-box; }
    body { margin: 0; font-family: 'IBM Plex Sans', system-ui, sans-serif; color: #0f172a; }
    .toolbar { padding: 12px; background:#f8fafc; border-bottom:1px solid #e2e8f0; display:flex; gap:8px; justify-content:flex-end; }
    .toolbar button { border:0; padding:8px 14px; border-radius:4px; cursor:pointer; font-size:12px; }
    .toolbar .primary { background:#0f172a; color:#fff; }
    .toolbar .secondary { background:#fff; color:#0f172a; border:1px solid #e2e8f0; }
    .sheet { display:grid; grid-template-columns: repeat(${format.cols}, ${format.w}mm); gap: 2mm; padding: 6mm; }
    .label {
      width: ${format.w}mm; height: ${format.h}mm; padding: 3mm;
      border: 1px dashed #cbd5e1; border-radius: 2mm;
      display: flex; flex-direction: column; justify-content: space-between;
      overflow: hidden; page-break-inside: avoid; break-inside: avoid;
    }
    .brand { font-size: 7pt; color:#64748b; text-transform:uppercase; letter-spacing:.08em; margin-bottom: 1mm; }
    .pname { font-size: 10pt; font-weight: 700; line-height: 1.15; overflow: hidden;
             display:-webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
    .barcode { display:flex; justify-content:center; align-items:center; margin: 1mm 0; }
    .barcode svg { width: 100%; height: 12mm; }
    .meta { display:flex; justify-content:space-between; font-size:7.5pt; color:#334155; }
    .meta b { color:#0f172a; font-weight:600; }
    @media print {
      .toolbar { display:none; }
      .label { border-color: transparent; }
    }
  `;

  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>Etichette prodotti</title>
    <link href="https://api.fontshare.com/v2/css?f[]=ibm-plex-sans@700,600,500,400&display=swap" rel="stylesheet"/>
    <style>${style}</style></head><body>
    <div class="toolbar">
      <button class="secondary" onclick="window.close()">Chiudi</button>
      <button class="primary" onclick="window.print()">Stampa etichette</button>
    </div>
    <div class="sheet">${expanded.map(cellHtml).join("")}</div>
    <script>setTimeout(() => window.focus(), 100);</script>
  </body></html>`;

  w.document.write(html);
  w.document.close();
}
